import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { useAccount } from 'wagmi';

type ShowTaycanEvmscanDrawerProps = {
  open: boolean;
  onClose: () => void;
};
export default function ShowTaycanEvmscanDrawer({ open, onClose }: ShowTaycanEvmscanDrawerProps) {
  const { address } = useAccount();
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          p: 3,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 0, top: 0, p: 0 }}>
          <Close />
        </IconButton>
        <Box mt={4.5} mb={2}>
          <Button
            size="large"
            variant="contained"
            fullWidth
            onClick={() => {
              document.location = `https://taycan-evmscan.hupayx.io/address/${address}`;
              // window.open(`https://taycan-evmscan.hupayx.io/address/${address}`);
            }}
          >
            Taycan-Evmscan에서 보기
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
